// extracted by mini-css-extract-plugin
export var footer = "LeadCaptureVersionTwo-module--footer--a5689";
export var myForm = "LeadCaptureVersionTwo-module--my-form--ddb1c";
export var parent = "LeadCaptureVersionTwo-module--parent--b335f";